import { Layout } from '@vwfs-bronson/bronson-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { EmailInput, PhonenumberInput, TextInput } from '../../simple-form-components';
import { RestrictedNumericSelection } from '../../simple-form-components/restricted-numeric-selection/RestrictedNumericSelection';
import { ProductTypeEN } from 'cpfr-common';
import { useFormikContext } from 'formik';
import { RequestInitialValues } from '../../../../initialValues';

interface ChangeDurationMileageFormProps {
    productTypeEn: ProductTypeEN | undefined;
    productType: string | undefined;
}

export const ChangeDurationMileageForm: React.FC<ChangeDurationMileageFormProps> = ({
    productTypeEn,
    productType,
}: ChangeDurationMileageFormProps) => {
    const { t } = useTranslation('request');
    const translationPrefix = 'category-selection.change-duration-mileage';

    const { values } = useFormikContext();

    const translate = (key: string): string => {
        return t(`${translationPrefix}.${key}`);
    };

    const isTotalDurationMandatory =
        !!(values as RequestInitialValues)?.changeDurationMileage?.email &&
        (((productTypeEn === ProductTypeEN.OPERATIVE_LEASING || productTypeEn === ProductTypeEN.VDL) &&
            !(values as RequestInitialValues)?.changeDurationMileage?.desiredMileage) ||
            productTypeEn === ProductTypeEN.CREDIT);

    const isDesiredMileageMandatory =
        !!(values as RequestInitialValues)?.changeDurationMileage?.email &&
        (((productTypeEn === ProductTypeEN.OPERATIVE_LEASING || productTypeEn === ProductTypeEN.VDL) &&
            !(values as RequestInitialValues)?.changeDurationMileage?.totalDuration) ||
            productTypeEn === ProductTypeEN.BALLON_LEASING ||
            (productTypeEn === ProductTypeEN.FINANCIAL_LEASE && !!productType));

    return (
        <>
            <Layout.Item>
                <p
                    dangerouslySetInnerHTML={{
                        __html: translate('description'),
                    }}
                />
            </Layout.Item>
            <Layout.Item>
                <EmailInput
                    label={translate('email')}
                    name={'changeDurationMileage.email'}
                    inputId="email-change-duration-milage-form"
                />
            </Layout.Item>
            <Layout.Item>
                <PhonenumberInput
                    label={translate('phonenumber')}
                    name={'changeDurationMileage.phonenumber'}
                    isMandatory={false}
                    inputId="phone-number-change-duration-milage-form"
                />
            </Layout.Item>
            <Layout.Item>
                <RestrictedNumericSelection
                    label={translate('desired-duration.description')}
                    tooltip={translate('desired-duration.tooltip')}
                    tooltipTitle={translate('desired-duration.tooltip-title')}
                    tooltipAriaLabel={translate('desired-duration.tooltip-title')}
                    name={'changeDurationMileage.totalDuration'}
                    min={12}
                    max={60}
                    emptyByDefault={true}
                    isMandatory={isTotalDurationMandatory}
                />
            </Layout.Item>
            <Layout.Item>
                <RestrictedNumericSelection
                    label={translate('desired-mileage.description')}
                    name={'changeDurationMileage.desiredMileage'}
                    min={10000}
                    max={300000}
                    step={5000}
                    hint={translate('desired-mileage.hint')}
                    placeholder={translate('desired-mileage.placeholder')}
                    tooltip={translate('desired-mileage.tooltip')}
                    tooltipTitle={translate('desired-mileage.tooltip-title')}
                    tooltipAriaLabel={translate('desired-mileage.tooltip-title')}
                    emptyByDefault={true}
                    isMandatory={isDesiredMileageMandatory}
                />
            </Layout.Item>
            <Layout.Item>
                <RestrictedNumericSelection
                    label={translate('desired-tires-summer')}
                    name={'changeDurationMileage.desiredTiresSummer'}
                    tooltip={translate('desired-tires-tooltip')}
                    tooltipTitle={translate('desired-tires-summer-tooltip-title')}
                    tooltipAriaLabel={translate('desired-tires-summer-tooltip-title')}
                    min={2}
                    max={8}
                    step={2}
                    emptyByDefault={true}
                />
            </Layout.Item>
            <Layout.Item>
                <RestrictedNumericSelection
                    label={translate('desired-tires-winter')}
                    name={'changeDurationMileage.desiredTiresWinter'}
                    tooltip={translate('desired-tires-tooltip')}
                    tooltipTitle={translate('desired-tires-winter-tooltip-title')}
                    tooltipAriaLabel={translate('desired-tires-winter-tooltip-title')}
                    min={2}
                    max={8}
                    step={2}
                    emptyByDefault={true}
                />
            </Layout.Item>
            <Layout.Item>
                <TextInput label={translate('comment')} name={'changeDurationMileage.comment'} isMandatory={false} />
            </Layout.Item>
        </>
    );
};
